import './assets/ContentCard.css';const e = "#ffffff", r = "#396e75", o = "#e5fdff", a = "#546223", t = "#f0fae5", d = "#a65523", _ = "#fff1e8", l = "#7f3e3e", n = "#ffe2e2", c = "#62625a", g = "#f8f8e7", i = "#38539a", h = "#707070", p = "#c8f8d1", w = "#87c9c8", b = "#5291b1", m = "rgba(82, 145, 177, 0.1019607843)", k = "#445685", s = "#181d61", u = "rgba(24, 29, 97, 0.1019607843)", z = "#5969d6", V = "#ea999d", f = "#b6577e", C = "rgba(182, 87, 126, 0.1019607843)", y = "#7e3e80", B = "#1e247f", G = "rgba(30, 36, 127, 0.1019607843)", O = "#da7600", R = "#107f47", W = "#d91734", Y = "_html_9p69w_34", v = "_banner_9p69w_214", A = "_content_9p69w_203", P = "_header_9p69w_330", S = "_tag_9p69w_330", x = "_title_9p69w_341", j = "_description_9p69w_352", q = "_footer_9p69w_364", D = "_seperator_9p69w_398", E = "_dot_9p69w_406", F = {
  amwayWhite: e,
  darkBlue: r,
  lightBlue: o,
  darkGreen: a,
  lightGreen: t,
  darkOrange: d,
  lightOrange: _,
  darkRed: l,
  lightRed: n,
  darkYellow: c,
  lightYellow: g,
  darkPurple: i,
  darkGrayOnWhite: h,
  dataVizColor1: p,
  dataVizColor2: w,
  dataVizColor3: b,
  dataVizColor3Background: m,
  dataVizColor4: k,
  dataVizColor5: s,
  dataVizColor5Background: u,
  dataVizColor6: z,
  dataVizColor7: V,
  dataVizColor8: f,
  dataVizColor8Background: C,
  dataVizColor9: y,
  dataVizColor10: B,
  dataVizColor10Background: G,
  dataVizAlertOrange: O,
  dataVizSuccessGreen: R,
  dataVizWarningRed: W,
  html: Y,
  "theme-border-dark-red": "_theme-border-dark-red_9p69w_135",
  "theme-border-dark-blue": "_theme-border-dark-blue_9p69w_139",
  "theme-border-dark-orange": "_theme-border-dark-orange_9p69w_143",
  "theme-border-dark-green": "_theme-border-dark-green_9p69w_147",
  "theme-border-dark-purple": "_theme-border-dark-purple_9p69w_151",
  "theme-border-dark-gray": "_theme-border-dark-gray_9p69w_155",
  "theme-border-light-red": "_theme-border-light-red_9p69w_159",
  "theme-border-light-blue": "_theme-border-light-blue_9p69w_163",
  "theme-border-light-orange": "_theme-border-light-orange_9p69w_167",
  "theme-border-light-green": "_theme-border-light-green_9p69w_171",
  "theme-border-light-purple": "_theme-border-light-purple_9p69w_175",
  "theme-border-light-gray": "_theme-border-light-gray_9p69w_179",
  "theme-gradient-red": "_theme-gradient-red_9p69w_183",
  "theme-gradient-blue": "_theme-gradient-blue_9p69w_187",
  "theme-gradient-orange": "_theme-gradient-orange_9p69w_191",
  "theme-gradient-green": "_theme-gradient-green_9p69w_195",
  "theme-gradient-purple": "_theme-gradient-purple_9p69w_199",
  "content-card-link": "_content-card-link_9p69w_203",
  "content-card-container": "_content-card-container_9p69w_207",
  banner: v,
  "content-card-image": "_content-card-image_9p69w_219",
  "icon-container": "_icon-container_9p69w_222",
  "download-icon-container": "_download-icon-container_9p69w_241",
  "pdf-banner": "_pdf-banner_9p69w_259",
  "pdf-banner-wrapper": "_pdf-banner-wrapper_9p69w_268",
  content: A,
  "theme-dark-blue": "_theme-dark-blue_9p69w_282",
  "theme-dark-green": "_theme-dark-green_9p69w_286",
  "theme-dark-orange": "_theme-dark-orange_9p69w_290",
  "theme-dark-red": "_theme-dark-red_9p69w_294",
  "theme-dark-purple": "_theme-dark-purple_9p69w_298",
  "theme-dark-gray": "_theme-dark-gray_9p69w_302",
  "theme-light-blue": "_theme-light-blue_9p69w_306",
  "theme-light-green": "_theme-light-green_9p69w_310",
  "theme-light-orange": "_theme-light-orange_9p69w_314",
  "theme-light-red": "_theme-light-red_9p69w_318",
  "theme-light-purple": "_theme-light-purple_9p69w_322",
  "theme-light-gray": "_theme-light-gray_9p69w_326",
  header: P,
  tag: S,
  title: x,
  description: j,
  footer: q,
  "footer-line": "_footer-line_9p69w_371",
  "resource-card-content": "_resource-card-content_9p69w_378",
  "promotion-card-content": "_promotion-card-content_9p69w_381",
  "resource-card-container": "_resource-card-container_9p69w_385",
  seperator: D,
  "vertical-line": "_vertical-line_9p69w_401",
  dot: E,
  "card-bg-color-light-orange": "_card-bg-color-light-orange_9p69w_413",
  "card-bg-color-white": "_card-bg-color-white_9p69w_417",
  "card-bg-color-amway-white": "_card-bg-color-amway-white_9p69w_418",
  "card-bg-color-light-red": "_card-bg-color-light-red_9p69w_422",
  "card-bg-color-light-blue": "_card-bg-color-light-blue_9p69w_426",
  "card-bg-color-light-green": "_card-bg-color-light-green_9p69w_430",
  "card-bg-color-light-yellow": "_card-bg-color-light-yellow_9p69w_434",
  "card-bg-color-light-purple": "_card-bg-color-light-purple_9p69w_438",
  "card-bg-color-light-gray": "_card-bg-color-light-gray_9p69w_442",
  "card-color-dark-orange": "_card-color-dark-orange_9p69w_446",
  "card-color-black": "_card-color-black_9p69w_450",
  "card-color-amway-black": "_card-color-amway-black_9p69w_451",
  "card-color-dark-red": "_card-color-dark-red_9p69w_455",
  "card-color-dark-blue": "_card-color-dark-blue_9p69w_459",
  "card-color-dark-green": "_card-color-dark-green_9p69w_463",
  "card-color-dark-yellow": "_card-color-dark-yellow_9p69w_467",
  "card-color-dark-purple": "_card-color-dark-purple_9p69w_471"
};
export {
  F as s
};
//# sourceMappingURL=ContentCard.module-4f028727.mjs.map
